import { registerMutation } from 'data-fetching-client';
import { postHubTrialStartRpc } from 'trials-service-types';
import { rpcClient } from '../client';
export const startTrial = queryParameters => rpcClient.call(postHubTrialStartRpc, {
  queryParameters
});
export const START_TRIAL_MUTATION = registerMutation({
  fieldName: 'trialStart',
  args: ['existingUser', 'ignorePastTrials', 'internal', 'isWebsiteTrial', 'trialSource', 'trialId'],
  fetcher: startTrial
});